import Breadcrumb from 'components/desktop/shared/breadcrumb';
import IntroduceAndContact from './introduce-and-contact';
import QuestionList from './question-list';
import TermOfAgreement from './term-of-agreement';

const MainConent = () => (
  <div className='js-toc-content flex w-full flex-col space-y-[24px] rounded-[16px] bg-paper py-[28px] px-[24px] shadow-1'>
    <Breadcrumb breadcrumbs={[{ name: 'Thông tin chung' }]} />
    <IntroduceAndContact />
    <QuestionList />
    <TermOfAgreement />
  </div>
);

export default MainConent;
